/*LIBRARY*/
import { useState, useEffect, useRef, useCallback, useContext } from "react";
import { connect } from "react-redux";

/*COMPONENT*/

/*REDUX*/
import {
  searchLayersOnlyV2,
  searchLayersOnlyCount,
  clearSearchLayer,
  loadMoreSearchLayersOnlyV2,
} from "../../App/actions/layerActions";
import { attachLayer } from "../../App/actions/layerNewActions";
import {
  get_data_premium_count,
  search_data_premium,
  get_data_premium_by_category_id,
  load_more_search_data_premium,
  empty_data_premium_by_category_id,
  get_data_premium_by_category_id_count,
  reset_get_data_premium_by_category_id_count,
} from "../../App/actions/moneyActions";
import { clone_layer } from "../../App/actions/propertiesActions";
import { is_has_license_basic_or_license_sharing } from "../../App/actions/filter_license";
import { post_activities } from "../../App/actions/activities";

/*PICTURE*/
import pic_static from "../../Assets/svg/profile_pic_comment.svg";

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";
import { ErrorContext } from "../../Debug/ErrorHandler/ErrorContext";
import { set_value_user } from "../../App/actions/authActions";

/*CONST*/
const WAIT_INTERVAL = 1000;
const ENTER_KEY = 13;

const sort_item = (array, lang, isFromSmall) => {
  if (lang) {
    if (isFromSmall) {
      function compare(a, b) {
        if (a?._id?.[lang] < b?._id?.[lang]) return -1;
        if (a?._id?.[lang] > b?._id?.[lang]) return 1;
        return 0;
      }
      return array.sort(compare);
    } else {
      function compare(a, b) {
        if (a?._id?.[lang] < b?._id?.[lang]) return 1;
        if (a?._id?.[lang] > b?._id?.[lang]) return -1;
        return 0;
      }
      return array.sort(compare);
    }
  } else {
    if (isFromSmall) {
      function compare(a, b) {
        if (a < b) return -1;
        if (a > b) return 1;
        return 0;
      }
      return array.sort(compare);
    } else {
      function compare(a, b) {
        if (a < b) return 1;
        if (a > b) return -1;
        return 0;
      }
      return array.sort(compare);
    }
  }
};

const SEARCH_LAYER = (props) => {
  const {
    auth,
    layer,
    project,
    blog,
    block_license_with_handler,
    clone_layer: clone_layer_action,
    searchLayersOnlyV2: search_layers_only_v2,
    searchLayersOnlyCount: search_layers_only_count,
    clearSearchLayer: clear_search_layer,
    attachLayer: attach_layer,
    loadMoreSearchLayersOnlyV2: load_more_search_layers_only_v2,
    get_data_premium_count: get_data_premium_count_action,
    search_data_premium: search_data_premium_action,
    get_data_premium_by_category_id: get_data_premium_by_category_id_action,
    load_more_search_data_premium: load_more_search_data_premium_action,
    empty_data_premium_by_category_id: empty_data_premium_by_category_id_action,
    get_data_premium_by_category_id_count:
      get_data_premium_by_category_id_count_action,
    reset_get_data_premium_by_category_id_count:
      reset_get_data_premium_by_category_id_count_action,
    is_has_license_basic_or_license_sharing:
      is_has_license_basic_or_license_sharing_action,
    set_value_user: set_value_user_action,
    post_activities: post_activities_action,
  } = props;

  const [search_params, set_search_params] = useState("");
  const [category_id, set_category_id] = useState("");
  const [geo_layer, set_geo_layer] = useState({});
  const [mode, set_mode] = useState("premium"); //private | premium
  const [layers_attach_id, set_layers_attach_id] = useState([]);
  const [layers_import_id, set_layers_import_id] = useState([]);
  const [data_skip, set_data_skip] = useState({ private: 0, premium: 0 });
  const [isTyping, set_isTyping] = useState(false);
  const [geo_layer_list_scroll_position, set_geo_layer_list_scroll_position] =
    useState(0);

  // Error handling context
  const { handleError } = useContext(ErrorContext);

  const containerRef = useRef(null);
  const timer_ref = useRef(null);

  useEffect(() => {
    handleError(() => {
      const list_id = layer.geo_layer_list.map((l) => l._id);
      set_layers_attach_id(list_id);
      get_data_premium_count_action();
    })();

    return () => {
      handleError(() => {
        set_search_params("");
        set_geo_layer({});
        set_mode("private");
        set_data_skip({ private: 0, premium: 0 });
      })();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    handleError(() => {
      if (containerRef.current) {
        containerRef.current.scrollTop = geo_layer_list_scroll_position;
      }
    })();
  });

  const trigger_change = useCallback(
    (
      current_search_params,
      current_mode,
      current_category_id,
      current_data_skip,
    ) => {
      handleError(() => {
        // FIX: Only trigger search if keyword is longer than 3 characters
        if (current_search_params.length > 3) {
          if (current_mode === "private") {
            search_layers_only_v2(current_search_params);
            search_layers_only_count(current_search_params);
            set_data_skip((prev) => ({
              ...prev,
              private: prev.private + 20,
            }));
            set_isTyping(false);
            set_geo_layer_list_scroll_position(0);
          } else if (current_mode === "premium") {
            search_data_premium_action(
              current_search_params,
              current_category_id,
            );
            get_data_premium_by_category_id_count_action(
              current_search_params,
              current_category_id,
            );
            set_data_skip((prev) => ({
              ...prev,
              premium: prev.premium + 20,
            }));
            set_isTyping(false);
            set_geo_layer_list_scroll_position(0);

            post_activities_action({
              action: "search_premium",
              keyword: current_search_params,
            });
          }
        }
        // FIX: Ensure resetting works when the user completely clears the input
        else if (current_search_params.length === 0) {
          if (current_mode === "premium") {
            if (!current_category_id) {
              // jika tidak ada search_params dan category_id maka reset data untuk geo layer list count
              reset_get_data_premium_by_category_id_count_action();
            } else {
              // jika tidak ada search_params tetapi ada category_id maka lakukan pencarian berdasarkan category_id saja
              search_data_premium_action("", current_category_id);
              get_data_premium_by_category_id_count_action(
                "",
                current_category_id,
              );
              set_data_skip((prev) => ({
                ...prev,
                premium: current_data_skip.premium + 20,
              }));
              set_isTyping(false);
              set_geo_layer_list_scroll_position(0);
            }
          }
        }
      })();
    },
    [
      handleError,
      search_layers_only_v2,
      search_layers_only_count,
      search_data_premium_action,
      get_data_premium_by_category_id_count_action,
      post_activities_action,
      reset_get_data_premium_by_category_id_count_action,
    ],
  );

  const on_get_data_premium_by_category_id = useCallback(
    (clicked_category_id) => {
      handleError(() => {
        set_geo_layer_list_scroll_position(0);
        let new_category_id;
        if (clicked_category_id === category_id) {
          new_category_id = "";
          set_category_id("");
          set_geo_layer_list_scroll_position(0);
          set_data_skip({ premium: 20 });
          if (!search_params) {
            empty_data_premium_by_category_id_action();
            set_category_id(new_category_id);
            set_data_skip({ premium: 20 });
            set_geo_layer_list_scroll_position(0);
            return;
          }
        } else {
          new_category_id = clicked_category_id;
          set_category_id(clicked_category_id);
          set_data_skip({ premium: 20 });
        }
        get_data_premium_by_category_id_action(new_category_id, search_params);
        get_data_premium_by_category_id_count_action(
          search_params,
          new_category_id,
        );
      })();
    },
    [
      handleError,
      category_id,
      search_params,
      empty_data_premium_by_category_id_action,
      get_data_premium_by_category_id_action,
      get_data_premium_by_category_id_count_action,
    ],
  );

  const handle_mode = useCallback(
    (new_mode) => {
      handleError(() => {
        set_mode(new_mode);
        set_search_params("");
        clear_search_layer();
      })();
    },
    [handleError, clear_search_layer],
  );

  const handle_push_project = useCallback(
    (pushed_geo_layer) => {
      handleError(() => {
        if (
          is_has_license_basic_or_license_sharing_action() ||
          mode !== "premium"
        ) {
          //jika lolos maka jalankan fungsi import data
          set_layers_attach_id((prev) => [...prev, pushed_geo_layer._id]);
          set_geo_layer(pushed_geo_layer);
          const geo_project_id = project?.geo_project?._id;
          const body = { geo_project_id, geo_layer: pushed_geo_layer };
          attach_layer(body);
          post_activities_action({
            action: "attach_premium",
            layer_id: pushed_geo_layer._id,
          });
        } else {
          //jika tidak lolos maka toggle penawaran pricing
          block_license_with_handler();
        }
      })();
    },
    [
      handleError,
      is_has_license_basic_or_license_sharing_action,
      mode,
      project,
      attach_layer,
      block_license_with_handler,
      post_activities_action,
    ],
  );

  const handle_download = useCallback(
    (downloaded_geo_layer) => {
      //mode = private || premium
      handleError(() => {
        if (
          is_has_license_basic_or_license_sharing_action() ||
          mode !== "premium"
        ) {
          //jika lolos maka jalankan fungsi import data
          set_layers_import_id((prev) => [...prev, downloaded_geo_layer._id]);
          set_geo_layer(downloaded_geo_layer);
          const geo_project_link = project?.geo_project?.link;
          const { user } = auth;
          const body = {
            geo_layer_id: downloaded_geo_layer?._id,
            geo_project_id: project?.geo_project?._id,
            user_id: user?._id,
            new_name: downloaded_geo_layer?.name,
            status: `import_${mode}`,
          };
          clone_layer_action(body, geo_project_link);
          post_activities_action({
            action: "import_premium",
            layer_id: downloaded_geo_layer?._id,
          });
        } else {
          //jika tidak lolos maka toggle penawaran pricing
          set_value_user_action("modal_block_sini_ai_sini_data", true);
        }
      })();
    },
    [
      handleError,
      is_has_license_basic_or_license_sharing_action,
      mode,
      project?.geo_project?.link,
      project?.geo_project?._id,
      auth,
      clone_layer_action,
      post_activities_action,
      set_value_user_action,
    ],
  );

  const handle_change = useCallback(
    (e) => {
      handleError(() => {
        if (layer.search_result_list.geo_layer_list.length > 0) {
          clear_search_layer();
        }

        const value = e.target.value;
        clearTimeout(timer_ref.current);
        set_search_params(value);
        set_isTyping(true);
        set_data_skip({ private: 0, premium: 0 });

        timer_ref.current = setTimeout(() => {
          trigger_change(value, mode, category_id, { private: 0, premium: 0 });
        }, WAIT_INTERVAL);
      })();
    },
    [
      handleError,
      layer.search_result_list.geo_layer_list.length,
      clear_search_layer,
      trigger_change,
      mode,
      category_id,
    ],
  );

  const handle_key_down = useCallback(
    (e) => {
      handleError(() => {
        if (e.keyCode === ENTER_KEY) {
          // Clear the debounce timer if the user presses enter manually
          // This prevents the search from firing a second time!
          clearTimeout(timer_ref.current);
          trigger_change(search_params, mode, category_id, data_skip);
        }
      })();
    },
    [handleError, trigger_change, search_params, mode, category_id, data_skip],
  );

  const handle_load_more = useCallback(() => {
    handleError(() => {
      // Save scroll position before load more
      const scroll_position =
        containerRef.current.scrollTop + containerRef.current.clientHeight - 30;

      // Helper function to update state and call the appropriate loadMore function
      const load_more_data = (load_function, skip_key) => {
        const current_skip = data_skip[skip_key];
        if (current_skip >= 20) {
          if (mode === "premium") {
            load_function(search_params || "", category_id, current_skip);
          } else if (mode === "private") {
            load_function(search_params, current_skip);
          }

          set_data_skip((prev) => ({
            ...prev,
            [skip_key]: current_skip + 20,
          }));
          set_geo_layer_list_scroll_position(scroll_position);
        }
      };

      // Determine which loadMore function to call based on the mode
      switch (mode) {
        case "private":
          load_more_data(load_more_search_layers_only_v2, "private");
          break;
        case "premium":
          load_more_data(load_more_search_data_premium_action, "premium");
          break;
        default:
          break;
      }
    })();
  }, [
    handleError,
    data_skip,
    mode,
    search_params,
    category_id,
    load_more_search_layers_only_v2,
    load_more_search_data_premium_action,
  ]);

  //local storage
  const language = localStorage?.language || auth.language;

  //global props
  const { loading_status, loading_item } = layer;
  const { geo_layer_list, geo_layer_list_count } = layer.search_result_list;
  let { data_premium_count } = blog;

  data_premium_count = sort_item(data_premium_count, language, true);

  //content
  let result_content = [];

  if (loading_status && loading_item === "search_layer") {
    result_content = (
      <div className="container_grey">{dict["Searching"][language]}...</div>
    );
  } else if (geo_layer_list?.length === 0 && !geo_layer_list_count) {
    result_content = !isTyping && !loading_status && (
      <div className="container_grey">{dict["No result"][language]}</div>
    );
  } else if (
    !loading_status &&
    loading_item !== "search_layer" &&
    geo_layer_list?.length > 0 &&
    geo_layer_list_count
  ) {
    result_content = (
      <div>
        {geo_layer_list?.map((geo_layer_item, idx) => {
          const { _id, name, geo_project } = geo_layer_item;
          const description = geo_layer_item?.description;
          const geo_project_name = geo_project?.name;
          const full_name = geo_layer_item?.user?.full_name
            ? geo_layer_item?.user?.full_name
            : geo_layer_item?.user?.name;
          const profile_picture = geo_layer_item?.user?.profile_picture
            ? geo_layer_item?.user?.profile_picture
            : {};
          let button_attach = null;
          let button_download = null;
          if (
            loading_status &&
            loading_item === "push_project_attach" &&
            geo_layer?._id === _id
          ) {
            button_attach = (
              <div className="button background_black">
                {dict["Importing"][language]}...
              </div>
            );
          } else if (
            loading_status &&
            loading_item === "download_layer" &&
            geo_layer?._id === _id
          ) {
            button_download = (
              <button className="button background_black">
                {dict["Downloading"][language]}...
              </button>
            );
          } else {
            button_attach = (
              <main style={{ marginBottom: "10px" }}>
                <button
                  onClick={() => handle_push_project(geo_layer_item)}
                  className="button background_black"
                  data-mapid={`clickAttach-${idx}`}
                >
                  {dict["Attach"][language]}
                </button>
                <section className="text_inferior">
                  {dict["Attach layers"][language]}{" "}
                  <b>{dict["NOT EDITABLE"][language]}</b>
                </section>
              </main>
            );
            button_download = (
              <main>
                <button
                  onClick={() => handle_download(geo_layer_item)}
                  className="button background_black"
                  data-mapid={`clickImport-${idx}`}
                >
                  {dict["Import"][language]}
                </button>
                <section className="text_inferior">
                  {dict["Import layers"][language]}{" "}
                  <b>{dict["EDITABLE"][language]}</b>
                </section>
              </main>
            );
            if (layers_attach_id?.includes(_id)) {
              button_attach = (
                <main style={{ marginBottom: "10px" }}>
                  <button className="button background_black" id="grey">
                    {dict["Attached"][language]}
                  </button>
                  <section className="text_inferior">
                    {dict["Attach layers"][language]}{" "}
                    <b>{dict["NOT EDITABLE"][language]}</b>
                  </section>
                </main>
              );
            }
            if (layers_import_id?.includes(_id)) {
              button_download = (
                <main>
                  <button className="button background_black" id="grey">
                    {dict["Imported"][language]}
                  </button>
                  <section className="text_inferior">
                    {dict["Import layers"][language]}{" "}
                    <b>{dict["EDITABLE"][language]}</b>
                  </section>
                </main>
              );
            }
          }
          return (
            <main
              key={idx}
              className="container background_white margin_bottom outline_grey"
            >
              <main className="two_container_auto">
                <section style={{ textAlign: "left" }}>
                  <div className="text_bold">
                    {idx + 1}
                    {". "}
                    {name}
                  </div>
                  {description && (
                    <div className="text_inferior">{description}</div>
                  )}
                  <div className="text_inferior">
                    {dict["Project"][language]}: {geo_project_name}
                  </div>
                  <div
                    alt={_id}
                    className={`photo_${_id} marginTop_5`}
                    samesite="None"
                    secure="true"
                  />
                  <p
                    style={{
                      display: "inline-block",
                      verticalAlign: "middle",
                      marginLeft: "10px",
                      fontSize: "12px",
                    }}
                    className="marginTop_5"
                  >
                    {full_name}
                  </p>
                  <style>
                    {`.photo_${_id}{
                    background: url(${
                      profile_picture && profile_picture?.url_compressed
                        ? profile_picture?.url_compressed
                        : profile_picture &&
                            profile_picture?.url &&
                            profile_picture?.url !==
                              "https://s3-us-west-2.amazonaws.com/geomapid-assets/astronot.png" &&
                            profile_picture?.url !== "-" &&
                            profile_picture?.url !== "default"
                          ? profile_picture?.url
                          : pic_static
                    }) no-repeat center center/ cover;
                    background-color: #c1c1c1;
                    height:40px;
                    width:40px;
                    border-radius: 50%;
                    border: 2px solid #2196f3;
                    display: inline-block;
                    align: center;
                    vertical-align: middle;
      }`}
                  </style>
                </section>
                <section style={{ textAlign: "right" }}>
                  {button_attach}
                  {button_download}
                </section>
              </main>
            </main>
          );
        })}
      </div>
    );
  }

  const load_more_button = (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
      onClick={handle_load_more}
    >
      <button className="button background_black">Load More</button>
    </div>
  );

  return (
    <main style={{ height: "100%", overflow: "auto" }}>
      <main>
        <section className="text_medium sub_color margin_bottom">
          {
            dict[
              "Search layer from all your project or public layer then import it to this project."
            ][language]
          }
          <br />
          {search_params &&
            !(loading_status && loading_item === "search_layer") &&
            `(${dict["Result"][language]}: ${geo_layer_list?.length} ${dict["from"][language]} ${geo_layer_list_count || 0} data)`}
        </section>

        <section className="text_center margin_bottom_extra">
          <button
            onClick={() => handle_mode("private")}
            className={`button noselect use_margin outline_shadow_soft ${
              mode === "private" ? "background_black" : "button_white"
            }`}
            data-mapid="clickDataKamu"
          >
            {dict["Your Layers"][language]}
          </button>
          <button
            onClick={() => handle_mode("premium")}
            className={`button noselect use_margin outline_shadow_soft ${
              mode === "premium" ? "background_black" : "button_white"
            }`}
            data-mapid="clickDataPremium"
          >
            Data Premium
          </button>
        </section>

        <input
          className="input_square margin_bottom"
          type="text"
          placeholder={dict["Search layers"][language]}
          autoComplete="off"
          name="search_params"
          value={search_params}
          onChange={handle_change}
          onKeyDown={handle_key_down}
          data-mapid="searchDataKamu"
        />

        {mode === "premium" && (
          <section className="margin_bottom_extra">
            <h1 className="text_bold margin_bottom">Etalase data</h1>
            {data_premium_count?.map((item, idx) => {
              let name;
              if (item?._id?.idn) {
                if (language === "ina") {
                  name = item?._id?.idn;
                } else {
                  name = item?._id?.eng;
                }
              } else {
                name = "Other";
              }
              return (
                <section
                  key={idx}
                  className={`margin_right margin_bottom container outline_shadow_soft container_small ${
                    category_id === item?._id?._id
                      ? "bg_blue text_white"
                      : "button_white"
                  }`}
                  onClick={() =>
                    on_get_data_premium_by_category_id(item?._id?._id)
                  }
                  data-mapid={`clickPremium-${idx}`}
                >
                  <p className="text_bold">{name}</p>
                  <p className="text_medium">{item?.sum}</p>
                </section>
              );
            })}
          </section>
        )}

        <section
          ref={containerRef}
          style={{ height: "calc(( 85vh - 130px ))", overflowY: "auto" }}
        >
          {(search_params || category_id) && result_content}
          {geo_layer_list?.length &&
          geo_layer_list?.length < geo_layer_list_count &&
          !loading_status &&
          loading_item !== "search_layer"
            ? load_more_button
            : ""}
        </section>
      </main>
    </main>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  layer: state.layer,
  project: state.project,
  payment: state.payment,
  blog: state.blog,
  license_reducer: state.license_reducer,
});

export default connect(mapStateToProps, {
  clone_layer,
  searchLayersOnlyV2,
  searchLayersOnlyCount,
  clearSearchLayer,
  attachLayer,
  loadMoreSearchLayersOnlyV2,
  get_data_premium_count,
  search_data_premium,
  get_data_premium_by_category_id,
  load_more_search_data_premium,
  empty_data_premium_by_category_id,
  get_data_premium_by_category_id_count,
  reset_get_data_premium_by_category_id_count,
  is_has_license_basic_or_license_sharing,
  set_value_user,
  post_activities,
})(SEARCH_LAYER);
